module.exports = __webpack_public_path__ + "static/img/login-btn.ed90557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-btn.png
// module id = TH1s
// module chunks = 0